import { logger } from '@modules/logger';
import { createContext } from 'react';
import type { NavigationState, NavigationAction } from 'types';

const initialContext = {
  state: { collapsed: undefined, minimized: undefined, overridden: false },
  dispatch: () => logger.warn('dispatch not provided for layoutContext'),
};

interface layoutContextValues {
  state: NavigationState;
  dispatch: (action: NavigationAction) => void;
}

const layoutContext = createContext<layoutContextValues>(initialContext);

export { layoutContext };
